import Delete from '../../../../../shared/Icons/Delete';
import Header from './Header';
import LevelAndPointsRange from './Columns/LevelAndPointsRange';
import EquivalentActivitiesAndBenefit from './Columns/EquivalentActivitiesAndBenefit';
import AsyncButton from '../../../../../shared/Loading/AsyncButton';

const TableLevel = (props) => {
  const inputClassName = `w-20 rounded-md border border-gray-300 bg-white px-2 py-1 text-sm
    hover:border-purple-400 focus:outline-none focus:ring-2
    focus:ring-purple-500 focus:border-purple-500`
  return (
    <div className="hidden md:block">
      <table className="w-full border-collapse text-sm text-gray-700">
        <colgroup>
          <col className="w-[15%]" />
          <col className="w-[20%]" />
          <col className="w-[30%]" />
          <col className="w-[30%]" />
          <col className="w-[5%]" />
        </colgroup>
        <Header isEditor={props.isEditor} />
        <tbody>
          {props.levels.map((row) => (
            <tr key={row.Id} className="align-top">
              <LevelAndPointsRange
                theme={props.theme}
                row={row}
                isEditor={props.isEditor}
                updateImage={props.updateImage}
                getImageUrl={props.getImageUrl}
                inputClassName={inputClassName}
                setLevels={props.setLevels}
              />
              <EquivalentActivitiesAndBenefit
                row={row}
                isEditor={props.isEditor}
                setLevels={props.setLevels}
                deleteActivity={props.deleteActivity}
              />  
              {props.isEditor &&
                <td className={`border border-gray-300 px-4 py-4 font-semibold text-gray-800
                  align-middle ${props.isEditor ? 'bg-gray-50' : 'bg-white'}`}>
                  <AsyncButton light
                    onClick={() => props.deleteLevel(row.Id)}
                    className="p-1 text-red-500 hover:bg-red-50 rounded transition"
                  >
                    <Delete />
                  </AsyncButton>
                </td>
              }
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableLevel;
